module.exports = __webpack_public_path__ + "img/p3.f3c4f8bb.jpg";